import { makeObservable, observable, runInAction, action } from 'mobx';
import { makePersistable, stopPersisting } from 'mobx-persist-store';

export default class AppStore {
    rootStore;
    sidebarCollapsed = true;

    constructor(rootStore) {
        this.rootStore = rootStore;
        makeObservable(this, {
            sidebarCollapsed: observable,
            toggleSidebar: action
        });

        makePersistable(this, { name: 'app', properties: ['sidebarCollapsed'], storage: window.localStorage });
    }

    toggleSidebar = (cred) => {
        //var val = this.sidebarCollapsed;
        
        this.sidebarCollapsed = !this.sidebarCollapsed;
        //alert(this.sidebarCollapsed)
    }
  
}